__turbopack_context__.v({
  "list": "index-module__fGHnuG__list",
  "tab": "index-module__fGHnuG__tab",
  "tabLabel": "index-module__fGHnuG__tabLabel",
  "tabSection": "index-module__fGHnuG__tabSection",
});
